export enum PriceType {
  WHOLESALE = 'wholesale',
  RETAIL = 'retail',
}
